<template>
  <div v-if="registered">
    <Toolbar />

    <div class="container-xxl">
      <div class="card">
        <div class="card-body">
          <h1 class="page-title">Terminal já registrado</h1>
          <p><span class="badge bg-primary fs-5">{{terminal.terminal_name}}</span></p>
          <p>UID: <b>{{terminal.terminal_hash}}</b></p>
        </div>
      </div>
    </div>
  </div>
  <div v-else>

    <Toolbar />

    <div class="container-xxl">
      <div class="card">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="registerTerminal">
              <div class="mb-3">
                <label for="terminalName" class="form-label">Nome do Terminal</label>
                <input
                    id="terminalName"
                    v-model="terminalName"
                    type="text"
                    class="form-control w-50"
                    required
                />
              </div>
              <Button
                  type="submit"
                  label="Registar Terminal"
                  :loading="loading"
                  class="btn btn-primary"
              />
              <div v-if="message" :class="{'text-success': success, 'text-danger': !success}" class="mt-3">
                {{ message }}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from 'primevue/button'
import http from '@/helpers/http'
import Dropdown from "primevue/dropdown";
import InviteUser from "../user/InviteUser.vue";
import Toolbar from "../../components/layouts/auth/Toolbar.vue";
import alert from "@/helpers/alert";

export default {
  name: "RegisterTerminal",
  components: {
    Toolbar, InviteUser, Dropdown,
    Button
  },
  data() {
    return {
      terminalName: '',
      loading: false,
      message: '',
      success: false,
      terminal: null,
      registered: false,
    }
  },
  async mounted() {
    await this.validateTerminal();
    this.terminal = this.$store.state.auth.terminal;
    this.registered = !!this.terminal?.terminal_hash;
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
  },
  methods: {
    async validateTerminal() {
      await this.$store.dispatch('auth/validateTerminal');
    },
    async registerTerminal() {
      this.loading = true;
      this.message = '';
      try {
        await http.post(`/places/${this.place.id_place}/terminals/register`, {terminal_name: this.terminalName, terminal_type: 'SE'} ).then((response) => {
          this.$store.commit('auth/setTerminal', response.data);
        });
        alert.toastSuccess('Terminal registrado com sucesso!');
        this.success = true;
        this.terminalName = '';
        window.location.reload();
      } catch (e) {
        alert.toastError('Falha ao registrar terminal');
        this.message = 'Erro ao registrar terminal.';
        this.success = false;
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.page-title {
  border-bottom: 1px solid #eee;
  padding-bottom: 1rem;
}
</style>